<div>
  <h2>webmate Mobile Access Activation</h2>
  <div class="activation-btn">
   <p-button label="Download VPN Configuration" (click)="activateToken($event)"></p-button>
  </div>
</div>
